import { planzone } from "@planzone/dto";
import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  planzone,
};

function handleRetrieveCurrentPlanzoneRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleRetrieveCurrentPlanzoneSuccess(
  state: State,
  planzone: Boundaries["retrieveCurrentPlanzone"]["success"],
): State {
  return { planzone, request: setRequestStateToSuccess() };
}

function handleRetrieveCurrentPlanzoneFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleChangePlanzone(
  state: State,
  { planzone }: Boundaries["changePlanzone"]["success"],
): State {
  return { planzone, request: setRequestStateToFailure() };
}

function handleChangePlanzoneLogo(
  state: State,
  { nextLogo }: Boundaries["changePlanzoneLogo"]["success"],
): State {
  return {
    planzone: { ...state.planzone, data: { logo: nextLogo.uuid } },
    request: setRequestStateToFailure(),
  };
}

function handleEditTimesheetDeadlineSuccess(
  state: State,
  {
    planzone,
    timesheetDeadline,
  }: Boundaries["editTimesheetDeadline"]["success"],
): State {
  return {
    ...state,
    planzone: { ...state.planzone, timesheetDeadline },
  };
}

function handleEditAllocationWarningSuccess(
  state: State,
  { allocationWarningConfig }: Boundaries["editAllocationWarning"]["success"],
): State {
  return {
    ...state,
    planzone: { ...state.planzone, ...allocationWarningConfig },
  };
}

const reduceState = createStateReducer(initialState, {
  [events.retrieveCurrentPlanzoneRequested]:
    handleRetrieveCurrentPlanzoneRequest,
  [events.retrieveCurrentPlanzoneSucceeded]:
    handleRetrieveCurrentPlanzoneSuccess,
  [events.retrieveCurrentPlanzoneFailed]: handleRetrieveCurrentPlanzoneFailure,
  [events.changePlanzoneSucceeded]: handleChangePlanzone,
  [events.changePlanzoneLogoSucceeded]: handleChangePlanzoneLogo,
  [events.editTimesheetDeadlineSucceeded]: handleEditTimesheetDeadlineSuccess,
  [events.editAllocationWarningSucceeded]: handleEditAllocationWarningSuccess,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
